import { nanoid } from 'nanoid';
import { RegisterFcmTokenDocument, RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables } from './registerFcmToken.generated';
import { useEffect } from 'react';
import notification from '@shared/utils/notification';
import { isAndroid } from '@shared/constants/devices';
import { DeviceType } from '@mildang/graphql-artifact';
import { useMutation } from '@apollo/client';


export const getRegisterFcmTokenInput = async () => {
  const token = await notification.requestToken();

  if (!token) {
    return null;
  }

  const localforage = (await import('localforage')).default;
  let deviceId = await localforage.getItem<string>('device-id');
  if (!deviceId) {
    deviceId = nanoid(26);
    localforage.setItem('device-id', deviceId);
  }

  let deviceType: DeviceType;
  if (token.platform === 'ios') {
    deviceType = 'IOS';
  } else if (token.platform === 'android') {
    deviceType = 'ANDROID';
  } else {
    deviceType = isAndroid() ? 'ANDROID' : 'WEB';
  }
  return {
    deviceType,
    deviceId: deviceId as string,
    token: token.token,
  };
};

// FCM 토큰을 발급 받아 서버에 등록
export function useRegisterFcmToken() {
  const [registerFcmToken] = useMutation<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>(RegisterFcmTokenDocument);

  useEffect(() => {
    const handler = async () => {
      const input = await getRegisterFcmTokenInput();
      if (!input) {
        return;
      }
      registerFcmToken({
        variables: {
          input,
        },
      });
    };

    handler();
  }, []);

  return null;
}

export const RegisterFcmToken = () => {
  useRegisterFcmToken();
  return null;
};
